import { Attempt } from '../slices/activity-tracking/activity-tracking.slice.types.ts';

export const mapAttemptsHistory = (attempts: Attempt[]): string => {
  return attempts
    .map((attempt) => {
      return `${attempt.isCorrect ? 'Correct' : 'Incorrect'}\n${attempt.description}`;
    })
    .join('\n\n---\n\n');
};
